import Constant from '@/common/constant/Constant';
import MuiDateTimePicker from '../../common/form/datetime-picker';
import Utils from '@/common/utils/utils';
import { Button, Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import RenderTooltipTitles from './RenderTooltipTitles';

export default function DataPickerInput(props) {
    const { errorlist, name } = props;
    const defaultValue = props?.defaultValue || '';
    const [value, setValue] = useState(defaultValue);
    const [errorsDateField, setErrorDateField] = useState(errorlist)

    const dateFormat = props.data.structure.dateFormat;
    const minutesStep = props?.data?.structure?.minutesStep || 1;
    const isAddTicket = !props?.detailTicket || false;

    const getDateByFormat = (dateValue, format) => {
        let dateByFormat = '';
        switch (format) {
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM:
                dateByFormat = dateValue.format('YYYY/MM/DD HH:mm');
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD:
                dateByFormat = dateValue.format('YYYY/MM/DD');
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM:
                dateByFormat = dateValue.format('YYYY/MM');
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYY:
                dateByFormat = dateValue.format('YYYY');
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.HHMM:
                dateByFormat = dateValue.format('HH:mm');
                break;
            default:
                dateByFormat = dateValue.format('YYYY/MM/DD HH:mm');
        }
        return dateByFormat;
    };

    const onChangeDate = (dateValue, format) => {
        let dateByFormat = dateValue ? getDateByFormat(dateValue, format) : '';

        if (props?.data?.structure?.minutesStep) {
            const { status, errorMessage } = Utils.validateDateByMinutesStep(
                dateByFormat,
                props?.data?.structure?.minutesStep
            );

            if (!status) {    
                setValue(dateValue);
                props.setValue(props?.name, '');
                props?.setIsEdited(false);            
                return setErrorDateField(prevError => {
                    return {
                        ...prevError,
                        [props?.data?.id]: {
                            message: errorMessage
                        }
                    };
                });
            }
        }
       
        setValue(dateValue);
        props.setValue(props?.name, dateByFormat);

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
        }


        if (dateByFormat !== 'Invalid date') {
            setErrorDateField(preError=>{
                delete preError[name]
                return preError
            });
        }
    };

    const handleCloseDatePicker = () => {
        setValue(null);
        props.setValue(props?.name, '');
        if (props?.setIsEdited) {
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
            }
        }
    }

    useEffect(() => {
        props.register(props?.name);
        props.setValue(props?.name, props?.defaultValue ? props?.defaultValue : '');
    }, []);

    useEffect(() => {
        setValue(props.defaultValue ? props.defaultValue: null)
    },[props?.triggerReloadTicket])

    useEffect(() => {
        if (isAddTicket) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            setValue(defaultValue || null)
            props.setValue(props?.name, defaultValue || '');
        }
        let isKnowledgeForm = [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(props?.parentForm?.type);
        if (props?.isDraftMode || (props?.editTicket && !isKnowledgeForm)) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            setValue(defaultValue || null)
            props.setValue(props?.name, defaultValue || '');
        }
    }, [props?.parentForm]);

    const isDisableField = () => {
        return (
            props.data.structure.publicForCustomer == 2 ||
            props.viewFromProjectOfEscalateTicket ||
            !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
            props.hasEditFieldPermissions === false
        );
    };

    const getComponentPicker = () => {
        let componentPicker;
        switch (dateFormat) {
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER}
                            format="YYYY/MM/DD HH:mm"
                            ampm={false}
                            onChange={e =>
                                onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM)
                            }
                            disabled={props.data.structure.publicForCustomer === 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            errorlist={errorsDateField}
                            minutesStep={minutesStep}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER}
                            format="YYYY/MM/DD"
                            ampm={false}
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            onChange={e => onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD)}
                            errorlist={errorsDateField}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER}
                            format="YYYY/MM"
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            views={['year', 'month']}
                            ampm={false}
                            onChange={e => onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM)}
                            errorlist={errorsDateField}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.YYYY:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.DATE_PICKER}
                            format="YYYY"
                            views={['year']}
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            ampm={false}
                            onChange={e => onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.YYYY)}
                            errorlist={errorsDateField}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
                break;
            case Constant.SETTING_DATE_FIELD_FORMAT.HHMM:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.TIME_PICKER}
                            format="HH:mm"
                            ampm={false}
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            onChange={e => onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.HHMM)}
                            errorlist={errorsDateField}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
                break;
            default:
                componentPicker = (
                    <div className='itemDatePicker'>
                        <MuiDateTimePicker
                            className="field-date-picker form-control-wrapPicker form-control-hg40"
                            name={props.name}
                            defaultValue={value}
                            value={value}
                            typePicker={Constant.COMPONENT_DATETIME_PICKER.DATE_TIME_PICKER}
                            format="YYYY/MM/DD HH:mm"
                            ampm={false}
                            disabled={props.data.structure.publicForCustomer == 2 || props.viewFromProjectOfEscalateTicket || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false }
                            onChange={e =>
                                onChangeDate(e, Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM)
                            }
                            minutesStep={minutesStep}
                            errorlist={errorsDateField}
                        />
                        {(props.hasEditFieldPermissions && !isDisableField()) && (
                            <Button disabled={isDisableField()} className='close-DatePicker' onClick={handleCloseDatePicker}>
                                <img src="/assets/image/icon-close-datetime.svg" alt="" />
                            </Button>
                        )}
                    </div>
                );
        }

        return componentPicker;
    };

    return (
        <div className="form-addTicket">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? 
                    <RenderTooltipTitles {...props}/> :
                    <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            style={{paddingTop: '10px'}}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">{getComponentPicker()}</div>
        </div>
    );
}
